import { Link } from "react-router-dom";
import { playStoreUrl, trackEvent } from "./analytics";
import "./Footer.css";

/* ── Google Play 4-colour triangle (geometrically exact) ── */
const GooglePlayIcon = () => (
  <svg width="22" height="24" viewBox="0 0 512 512" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M48,59.49v393a4.33,4.33,0,0,0,7.37,3.07L260,256,55.37,56.42A4.33,4.33,0,0,0,48,59.49Z"
    />
    <path
      fill="#34A853"
      d="M345.8,174,89.17,32.64l-.07,0c-6.81-3.64-13.36.55-13.36,7.71L260,256Z"
    />
    <path
      fill="#EA4335"
      d="M89.1,479.36c0,7.16,6.55,11.35,13.36,7.71L345.8,338,260,256Z"
    />
    <path
      fill="#FBBC04"
      d="M447.34,230.13l-82.08-45.79L260,256l105.26,71.66,82.08-45.79a20.41,20.41,0,0,0,0-51.74Z"
    />
  </svg>
);

/* ── Apple logo ── */
const AppleIcon = () => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 814 1000"
    fill="white"
    aria-hidden="true"
  >
    <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-57.8-155.5-127.4C46 790.7 0 663 0 541.8c0-194.3 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z" />
  </svg>
);

/* ── Social icons ── */
const IgIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="white"
    aria-hidden="true"
  >
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);

const FbIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="white"
    aria-hidden="true"
  >
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.428c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.927-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
  </svg>
);

const YtIcon = () => (
  <svg
    width="19"
    height="14"
    viewBox="0 0 576 512"
    fill="white"
    aria-hidden="true"
  >
    <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
  </svg>
);

const XIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="white"
    aria-hidden="true"
  >
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
  </svg>
);

/* ── Column header icons ── */
const ChatIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="white"
    aria-hidden="true"
  >
    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
  </svg>
);

const PeopleIcon = () => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 24 18"
    fill="white"
    aria-hidden="true"
  >
    <path d="M16 8c1.66 0 2.99-1.34 2.99-3S17.66 2 16 2c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 2 8 2C6.34 2 5 3.34 5 5s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V16h14v-2.5C15 10.17 10.33 10 8 10zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V16h6v-2.5C23 11.17 18.33 10 16 10z" />
  </svg>
);

const ShieldIcon = () => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 24 28"
    fill="white"
    aria-hidden="true"
  >
    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
  </svg>
);

const MailIcon = () => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 24 19"
    fill="white"
    aria-hidden="true"
  >
    <path d="M20 0H4C2.9 0 2 .9 2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V2l8 5 8-5v2z" />
  </svg>
);

/* ── Inline contact icons (outline style) ── */
const EnvelopeOutline = () => (
  <svg
    width="15"
    height="12"
    viewBox="0 0 24 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="2" width="20" height="16" rx="2" />
    <polyline points="22,4 12,12 2,4" />
  </svg>
);

const GlobeOutline = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const PinOutline = () => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 24 28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell">
        <div className="sf-grid">
          {/* ── Col 1: Brand ── */}
          <div className="sf-brand">
            <Link className="brand sf-logo" to="/">
              <span className="tile">
                <img src="/logo.webp" alt="Baatcheet" width="512" height="512" loading="lazy" decoding="async" />
              </span>
              <span className="wm">
                <span className="en">Baat</span>
                <span className="hi">चीत</span>
              </span>
            </Link>

            <p className="sf-desc">
              A loud, colourful, scrappy desi adda for voice.
              <br />
              Real people, real talk, real Bharat.
            </p>

            <p className="sf-get-app">Get the App</p>

            <div className="sf-badges">
              <a
                className="sf-badge"
                href={playStoreUrl('footer')}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get it on Google Play"
                onClick={() => trackEvent('play_store_click', { location: 'footer' })}
              >
                <GooglePlayIcon />
                <span className="sf-badge-text">
                  <span className="sf-badge-top">GET IT ON</span>
                  <span className="sf-badge-bot">Google Play</span>
                </span>
              </a>
              <a
                className="sf-badge"
                href="#"
                aria-label="Download on the App Store"
              >
                <AppleIcon />
                <span className="sf-badge-text">
                  <span className="sf-badge-top">Download on the</span>
                  <span className="sf-badge-bot">App Store</span>
                </span>
              </a>
            </div>

            <div className="sf-social">
              <a
                className="sf-soc sf-soc-ig"
                href="https://www.instagram.com/____baatcheet____/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <IgIcon />
              </a>
              <a className="sf-soc sf-soc-fb" href="#" aria-label="Facebook">
                <FbIcon />
              </a>
              <a className="sf-soc sf-soc-yt" href="#" aria-label="YouTube">
                <YtIcon />
              </a>
              <a className="sf-soc sf-soc-x" href="#" aria-label="X (Twitter)">
                <XIcon />
              </a>
            </div>
          </div>

          {/* ── Col 2: Explore ── */}
          <div className="sf-col">
            <div className="sf-col-head">
              <span className="sf-col-ico">
                <ChatIcon />
              </span>
              <span className="sf-col-title">Explore</span>
            </div>
            <Link to="/">Home</Link>
            <Link to="/how-it-works">How it Works</Link>
            <Link to="/join-us">Join Us</Link>
            <Link to="/safety">Safety</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/download">Download</Link>
          </div>

          {/* ── Col 3: Connect ── */}
          <div className="sf-col">
            <div className="sf-col-head">
              <span className="sf-col-ico">
                <PeopleIcon />
              </span>
              <span className="sf-col-title">Connect</span>
            </div>
            <Link to="/partner-landing">Become a Partner</Link>
            <a href="mailto:baatcheet.connect@gmail.com">Help</a>
          </div>

          {/* ── Col 4: Legal ── */}
          <div className="sf-col">
            <div className="sf-col-head">
              <span className="sf-col-ico">
                <ShieldIcon />
              </span>
              <span className="sf-col-title">Legal</span>
            </div>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/refund-policy">Refunds Policy</Link>
            <Link to="/account-deletion">Account Deletion</Link>
          </div>

          {/* ── Col 5: Contact Us ── */}
          <div className="sf-col">
            <div className="sf-col-head">
              <span className="sf-col-ico">
                <MailIcon />
              </span>
              <span className="sf-col-title">Contact Us</span>
            </div>
            <div className="sf-contact">
              <span className="sf-contact-ico">
                <EnvelopeOutline />
              </span>
              <a
                href="mailto:baatcheet.connect@gmail.com"
                className="sf-contact-link"
              >
                baatcheet.connect@gmail.com
              </a>
            </div>
            <div className="sf-contact">
              <span className="sf-contact-ico">
                <GlobeOutline />
              </span>
              <Link to="/" className="sf-contact-link">
                baatcheetapp.in
              </Link>
            </div>
            <div className="sf-contact">
              <span className="sf-contact-ico">
                <PinOutline />
              </span>
              <span>India</span>
            </div>
          </div>
        </div>

        {/* ── Explore Topics ── */}
        <div className="sf-topics">
          <span className="sf-topics-label">Explore:</span>
          <Link to="/anonymous-chat-app">Anonymous Chat App</Link>
          <Link to="/voice-chat-app">Voice Chat App</Link>
          <Link to="/audio-chat-app">Audio Chat App</Link>
          <Link to="/talk-to-someone">Talk to Someone</Link>
          <Link to="/emotional-support">Emotional Support</Link>
          <Link to="/mental-wellness">Mental Wellness</Link>
          <Link to="/relationship-advice">Relationship Advice</Link>
          <Link to="/stress-relief">Stress Relief</Link>
          <Link to="/loneliness-help">Loneliness Help</Link>
          <Link to="/online-friends">Online Friends</Link>
          <Link to="/earn-money-talking-online">Earn Money Talking</Link>
          <Link to="/late-night-chat-app">Late Night Chat</Link>
          <Link to="/hindi-chat-app">Hindi Chat App</Link>
        </div>

        {/* ── Bottom bar ── */}
        <div className="sf-bottom">
          <span>
            © 2026 <span className="sf-bot-en">Baat</span>
            <span className="sf-bot-hi">चीत</span>
          </span>
          <span>DevEffica Pvt. Ltd.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
